module.exports = __webpack_public_path__ + "static/media/shower-rain.d447e812.png";